import React, { useCallback, useEffect, useRef, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Divider, Grid, Stack, Table, TableCell, TableContainer, TableHead, TableRow, Typography, Paper, TableBody, Checkbox, TableSortLabel, Box } from '@mui/material';

import { RadioListItem } from 'components/Input/Radio';
import {  Extension, FnAxios, FnDialog, I18n, formatNumber } from 'utilities/utilities';
import { TextBoxItem } from 'components/Input/TextBox';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { BtnAdd, BtnBack, BtnDelete, BtnEdit, BtnRemark, BtnSave } from 'components/Button/ButtonAll';
import { useLocation, useNavigate } from 'react-router';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import UploadFile from 'components/Input/UploadFile';
import InputNumberItem from 'components/Input/InputNumber';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import { TextAreaItem } from 'components/Input/TextArea';
import moment from 'moment';
import "../Equipment/Equipment.css";

const EquipmentReceiveForm = () => {

    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const navigate = useNavigate();
    const onBack = () => navigate("/EquipmentList?sMode=" + sMode);
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [arrImport, setarrImport] = useState([])
    const [isOpen, setisOpen] = useState<boolean>(false);
    const [isDeleteTable, setisDeleteTable] = useState<boolean>(false);
    const [isOpenDelete, setisOpenDelete] = useState<boolean>(false);
    const [nOrder, setnOrder] = useState(0);
    const [arrGovernmentUnit, setarrGovernmentUnit] = useState([]);
    const [arrMoneyType, setarrMoneyType] = useState([]);
    const [arrMethodType, setarrMethodType] = useState([]);
    const [arrEquipmentType, setarrEquipmentType] = useState([]);
    const [arrEquipmentUnit, setarrEquipmentUnit] = useState([]);
    const [sEquipmentType, setsEquipmentType] = useState("");
    const [sEquipmentUnit, setsEquipmentUnit] = useState("");
    const [nEquipmentType, setnEquipmentType] = useState(0);
    const [nEquipmentUnit, setnEquipmentUnit] = useState(0);
    const [isEdit, setEdit] = useState<boolean>(false);
    const [sEditID, setsEditID] = useState("");
    const [lstData, setData] = useState<EquipmentReceiveItem[]>([]);
    const [selected, setSelected] = useState<readonly number[]>([]);
    const isSelected = (id: number) => selected.indexOf(id) !== -1;

    const sMode = new URLSearchParams(searchParams).get("sMode");
    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });
    const formNew = useForm({
        shouldFocusError: true,
        mode: "all"
    });

    const formItem = useForm({
        shouldFocusError: true,
        mode: "all"
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission
    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const getFormInitial = () => {
        AxiosFn.Get(`Equipment/GetFormInitial`, {}, (result) => {
            setarrGovernmentUnit(result.lstGovernmentUnit);
            setarrMoneyType(result.lstMoneyType);
            setarrMethodType(result.lstMethodType);
            setarrEquipmentType(result.lstEquipmentType);
            setarrEquipmentUnit(result.lstEquipmentUnit);
            if (sID === null) {
                form.setValue(`nGovernmentUnitID`, result.nGovernmentUnit);
                form.setValue(`sGovernment`, "กรมทรัพยากรธรณี");
            }

        })
    }

    // Remark
    const onOpenModal = (nID, sRemark, IsDelete) => {
        setisOpen(true);
        setnOrder(nID);
        setisOpenDelete(IsDelete);
        form.setValue("sRemark", sRemark);
    };

    const onSummitRemark = () => {
        setisOpen(false);
        let sRemarkform = form.getValues(`sRemark`);
        let arrClone = lstData;
        if (arrClone.length > 0) {
            arrClone.forEach((f) => {
                f.sRemark = f.nID == nOrder ? sRemarkform : f.sRemark;
            });
        }
        setnOrder(0);
        setData([...arrClone]);

    }

    //Add TableItem
    const onSumitTable = (e) => {
        let arrEquipmentNo = lstData.length > 0 ? lstData.filter((m) => m.sEquipmentNo === e[`sEquipmentNo`]) : [];
        if (arrEquipmentNo.length > 0 && !isEdit) {
            DialogFn.Warning(`มีรหัสครุภัณฑ์ ${e[`sEquipmentNo`]} ในระบบแล้ว`);
        } else {
            if (isEdit) {
                let arrClone = lstData;
                if (arrClone.length > 0) {
                    arrClone.forEach((f) => {
                        f.sEquipmentNo = f.sID == sEditID ? e[`sEquipmentNo`] : f.sEquipmentNo;
                        f.sGFMISNo = f.sID == sEditID ? e[`sGFMISNo`] : f.sGFMISNo;
                        f.sSlipNo = f.sID == sEditID ? e[`sSlipNo`] : f.sSlipNo;
                        f.nEquipmentTypeID = f.sID == sEditID ? e[`nEquipmentTypeID`] : f.nEquipmentTypeID;
                        f.sEquipmentType = f.sID == sEditID ? nEquipmentType !== 99999999 ? sEquipmentType !== "" ? sEquipmentType : f.sEquipmentType : e[`sEquipmentType`] : f.sEquipmentType;
                        f.sEquipment = f.sID == sEditID ? e[`sEquipment`] : f.sEquipment;
                        f.nAmount = f.nAmount;
                        f.nEquipmentUnitID = f.sID == sEditID ? e[`nEquipmentUnitID`] : f.nEquipmentUnitID;
                        f.sEquipmentUnit = f.sID == sEditID ? nEquipmentUnit !== 99999999 ? sEquipmentUnit !== "" ? sEquipmentUnit : f.sEquipmentUnit : e[`sUnitName`] : f.sEquipmentUnit;
                        f.nPricePerUnit = f.sID == sEditID ? e[`nPricePerUnit`] : f.nPricePerUnit;
                        f.sRemark = f.sID == sEditID ? e[`sRemark`] : f.sRemark;
                        f.isHead = f.isHead;
                        f.nDepreciation = f.sID == sEditID ? e[`nDepreciation`] : f.nDepreciation;
                        f.nPriceIncludeVat = f.sID == sEditID ? e[`nPriceIncludeVat`] : f.nPriceIncludeVat;
                        f.nServiceLifeYear = f.sID == sEditID ? e[`nServiceLifeYear`] : f.nServiceLifeYear;
                        f.nEquipmentItemIDOrder = f.nEquipmentItemIDOrder;
                        f.nEquipmentIDOrder = f.nEquipmentIDOrder;
                        f.nParentID = f.nParentID;
                        f.IsDelete = f.IsDelete;
                    });
                }
                setData([...arrClone]);

            } else {
                let arrID = lstData.length > 0 ? lstData.map((m) => m.nOrder) : [];
                let nOrder = (arrID.length > 0 ? Math.max(...arrID) : 0) + 1;

                let arrnEquipmentID = lstData.length > 0 ? lstData.map((m) => m.nEquipmentIDOrder) : [];
                let nEquipmentIDOrder = (arrnEquipmentID.length > 0 ? Math.max(...arrnEquipmentID) : 0) + 1;

                let arrIDitem = lstData.length > 0 ? lstData.map((m) => m.nEquipmentItemIDOrder) : [];
                let nIDitem = (arrIDitem.length > 0 ? Math.max(...arrIDitem) : 0) + 1;

                let arrParentID = lstData.length > 0 ? lstData.map((m) => m.nParentID) : [];
                let nParentID = (arrIDitem.length > 0 ? Math.max(...arrParentID) : 0) + 1;

                let objDataComponent: EquipmentReceiveItem = {
                    sID: (lstData.length + 1) + "",
                    nID: (lstData.length + 1),
                    nEquipmentID: 0,
                    nOrder: nOrder,
                    sEquipmentNo: e[`sEquipmentNo`] ? e[`sEquipmentNo`] : "",
                    sGFMISNo: e[`sGFMISNo`] ? e[`sGFMISNo`] : "",
                    sSlipNo: e[`sSlipNo`] ? e[`sSlipNo`] : "",
                    nEquipmentTypeID: e[`nEquipmentTypeID`] ? e[`nEquipmentTypeID`] : null,
                    sEquipmentType: nEquipmentType !== 99999999 ? sEquipmentType : e[`sEquipmentType`],
                    sEquipment: e[`sEquipment`] ? e[`sEquipment`] : "",
                    nAmount: 1,
                    nEquipmentUnitID: e[`nEquipmentUnitID`] ? e[`nEquipmentUnitID`] : null,
                    sEquipmentUnit: nEquipmentUnit !== 99999999 ? sEquipmentUnit : e[`sUnitName`],
                    nPricePerUnit: e[`nPricePerUnit`] ? e[`nPricePerUnit`] : null,
                    sRemark: e[`sRemark`] ? e[`sRemark}`] : "",
                    isHead: true,
                    nDepreciation: e[`nDepreciation`] ? e[`nDepreciation`] : null,
                    nPriceIncludeVat: e[`nPriceIncludeVat`] ? e[`nPriceIncludeVat`] : null,
                    nServiceLifeYear: e[`nServiceLifeYear`] ? e[`nServiceLifeYear`] : null,
                    nEquipmentItemIDOrder: nIDitem,
                    nEquipmentIDOrder: nEquipmentIDOrder,
                    nParentID: nParentID,
                    IsDelete: false
                };
                setData([...lstData, objDataComponent]);
            }

            setEdit(false);
            setsEditID("");

            formItem.setValue(`sEquipmentNo`, null);
            formItem.setValue(`sGFMISNo`, null);
            formItem.setValue(`sSlipNo`, null);
            formItem.setValue(`nEquipmentTypeID`, null);
            formItem.setValue(`sEquipmentType`, null);
            formItem.setValue(`sEquipment`, null);
            formItem.setValue(`nEquipmentUnitID`, null);
            formItem.setValue(`nPricePerUnit`, null);
            formItem.setValue(`sRemark`, null);
            formItem.setValue(`sEquipmentType`, null);
            formItem.setValue(`sUnitName`, null);
            formItem.setValue(`nPriceIncludeVat`, null);
            formItem.setValue(`nServiceLifeYear`, null);
            formItem.setValue(`nDepreciation`, null);
        }

    };

    const onSumitTableItem = (nEquipmentID, nParentID) => {
        let arrNewItem = [];
        arrNewItem.push(...lstData);

        let arrID = lstData.length > 0 ? lstData.map((m) => m.nID) : [];
        let nID = (arrID.length > 0 ? Math.max(...arrID) : 0) + 1;

        let arrIDitem = lstData.length > 0 ? lstData.map((m) => m.nEquipmentItemIDOrder) : [];
        let nIDitem = (arrIDitem.length > 0 ? Math.max(...arrIDitem) : 0) + 1;

        let arrEquipmentIDOrder = lstData.length > 0 ? lstData.map((m) => m.nEquipmentIDOrder) : [];
        let nEquipmentIDOrderNew = (arrEquipmentIDOrder.length > 0 ? Math.max(...arrEquipmentIDOrder) : 0) + 1;

        let objNewItem: EquipmentReceiveItem = {};
        objNewItem.sID = nID + "";
        objNewItem.nID = nID;
        objNewItem.isHead = false;
        objNewItem.nParentID = nParentID;
        objNewItem.nEquipmentID = nEquipmentID;
        objNewItem.nEquipmentItemID = null;
        objNewItem.nEquipmentItemIDOrder = nIDitem;
        objNewItem.nEquipmentIDOrder = nEquipmentIDOrderNew;
        arrNewItem.push(objNewItem);
        let param = {
            lstDataReceive: arrNewItem,
        };
        AxiosFn.Post(`Equipment/GetDataTableEquipmentItem`, param, (result) => {
            setData(result.lstDataReceive);
        });
    };

    //คำนวณค่าเสื่อม
    const nSum = () => {

        let nPriceIncludeVat = formItem.getValues(`nPriceIncludeVat`);
        let nServiceLifeYear = formItem.getValues(`nServiceLifeYear`) ? formItem.getValues(`nServiceLifeYear`) : 1;
        let nDepreciation = nPriceIncludeVat / nServiceLifeYear;
        formItem.setValue(`nDepreciation`, nDepreciation.toFixed(2));
    }

    const onSubmit = (e) => {
        let objitem = formNew.getValues();
        if (Object.values(objitem).filter(f => f == null).length > 0) {
            document.getElementById("AddDuration").click();
        } else {
            let arrItem = [];
            lstData.forEach((item) => {
                let objtem: EquipmentReceiveItem = {};
                objtem.sEquipment = objitem[`sEquipment_${item.nID}`] ? objitem[`sEquipment_${item.nID}`] : item.sEquipment;
                objtem.nAmount = objitem[`nAmount_${item.nID}`] ? objitem[`nAmount_${item.nID}`] : item.nAmount;
                objtem.sEquipmentUnit = objitem[`sUnitName_${item.nID}`] ? objitem[`sUnitName_${item.nID}`] : item.sEquipmentUnit;
                objtem.nPricePerUnit = objitem[`nPricePerUnit_${item.nID}`] ? objitem[`nPricePerUnit_${item.nID}`] : item.nPricePerUnit;
                objtem.sRemark = objitem[`sRemark`] ? objitem[`sRemark`] : item.sRemark;
                objtem.isHead = item.isHead ? item.isHead : false;
                objtem.sID = item.sID;
                objtem.nID = item.nID;
                objtem.nOrder = item.nOrder;
                objtem.sEquipmentNo = item.sEquipmentNo;
                objtem.sGFMISNo = item.sGFMISNo;
                objtem.sSlipNo = item.sSlipNo;
                objtem.nEquipmentTypeID = item.nEquipmentTypeID;
                objtem.sEquipmentType = item.sEquipmentType;
                objtem.nEquipmentUnitID = item.nEquipmentUnitID;
                objtem.nDepreciation = item.nDepreciation;
                objtem.nPriceIncludeVat = item.nPriceIncludeVat;
                objtem.nServiceLifeYear = item.nServiceLifeYear;
                objtem.nEquipmentID = item.nEquipmentID;
                objtem.nParentID = item.nParentID;
                objtem.nEquipmentItemID = item.nEquipmentItemID;
                objtem.nEquipmentItemIDOrder = item.nEquipmentItemIDOrder;
                objtem.nEquipmentIDOrder = item.nEquipmentIDOrder;
                objtem.isDelete = item.isDelete
                arrItem.push(objtem);
            })
            setData(arrItem);

            let param = {
                sID: sID ? sID : "",
                sGovernment: form.getValues("sGovernment"),
                nGovernmentUnitID: form.getValues("nGovernmentUnitID"),
                sOrderNo: form.getValues("sOrderNo"),
                nReceiveDate: form.getValues("dReceive").valueOf(),
                nMoneyTypeID: form.getValues("nMoneyTypeID"),
                nMethodTypeID: form.getValues("nMethodTypeID"),
                sSellerName: form.getValues("sSellerName"),
                sAddress: form.getValues("sAddress"),
                fFile: arrImport ?? [],
                lstDataReceive: arrItem,
            };
            DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
                DialogFn.BlockUI();
                AxiosFn.Post(`Equipment/SaveReceiveEquipment`, param, (result) => {
                    DialogFn.UnBlockUI();
                    DialogFn.Success(`บันทึกสำเร็จ`);
                    DialogFn.CloseSubmit()
                    navigate("/EquipmentList?sMode=" + sMode);

                }, (err) => {
                    DialogFn.UnBlockUI();
                    if (!err.response) {
                        DialogFn.Warning(err.sMessage);
                    }
                });
            });
        }
    };
    const getReceiveMaterialEdit = () => {
        let Param = {
            sID: sID ? sID : ""
        };
        DialogFn.BlockUI();
        AxiosFn.Post(`Equipment/GetReceiveEquipmentEdit`, Param, (result) => {
            DialogFn.UnBlockUI();
            if (sID) {
                result.lstDataReceive.filter(w => w.isHead === false).forEach(f => {
                    f.isHead = f.isHead
                    f.nID = +f.sID
                    formNew.setValue(`sEquipment_${f.nID}`, f.sEquipment);
                    formNew.setValue(`nAmount_${f.nID}`, f.nAmount);
                    formNew.setValue(`sUnitName_${f.nID}`, f.sEquipmentUnit);
                    formNew.setValue(`nPricePerUnit_${f.nID}`, f.nPricePerUnit);
                    formNew.setValue(`sRemark`, f.sRemark);

                });

                setisDeleteTable(result.isDelete);
                setData(result.lstDataReceive);
                form.setValue(`sGovernment`, result.sGovernment);
                form.setValue("nGovernmentUnitID", result.nGovernmentUnitID);
                form.setValue("sOrderNo", result.sOrderNo);
                form.setValue("dReceive", moment(result.nReceiveDate));
                form.setValue("nMoneyTypeID", result.nMoneyTypeID);
                form.setValue("nMethodTypeID", result.nMethodTypeID);
                form.setValue("sSellerName", result.sSellerName);
                form.setValue("sAddress", result.sAddress);
                setarrImport([...result.fFile]);

            }

        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };

    useEffect(() => {
        getReceiveMaterialEdit();
        getFormInitial();

    }, []);

    const onEdit = (sID, ObjData) => {
        setEdit(true);
        setsEditID(sID);
        let ObjProblem = {
            sEquipmentNo: ObjData.sEquipmentNo,
            sGFMISNo: ObjData.sGFMISNo,
            sSlipNo: ObjData.sSlipNo,
            nEquipmentTypeID: ObjData.nEquipmentTypeID,
            sEquipmentType: ObjData.sEquipmentType,
            sEquipment: ObjData.sEquipment,
            nEquipmentUnitID: ObjData.nEquipmentUnitID,
            sEquipmentUnit: ObjData.sEquipmentUnit,
            nPricePerUnit: ObjData.nPricePerUnit,
            nPriceIncludeVat: ObjData.nPriceIncludeVat,
            nServiceLifeYear: ObjData.nServiceLifeYear,
            nDepreciation: ObjData.nDepreciation,
        };
        setnEquipmentType(ObjProblem.nEquipmentTypeID);
        setnEquipmentUnit(ObjProblem.nEquipmentUnitID);
        formItem.setValue(`sEquipmentNo`, ObjProblem.sEquipmentNo);
        formItem.setValue(`sGFMISNo`, ObjProblem.sGFMISNo);
        formItem.setValue(`sSlipNo`, ObjProblem.sSlipNo);
        formItem.setValue(`nEquipmentTypeID`, ObjProblem.nEquipmentTypeID);
        formItem.setValue(`sEquipmentType`, ObjProblem.sEquipmentType);
        formItem.setValue(`sEquipment`, ObjProblem.sEquipment);
        formItem.setValue(`nEquipmentUnitID`, ObjProblem.nEquipmentUnitID);
        formItem.setValue(`sUnitName`, ObjProblem.sEquipmentUnit);
        formItem.setValue(`nPricePerUnit`, ObjProblem.nPricePerUnit);
        formItem.setValue(`nPriceIncludeVat`, ObjProblem.nPriceIncludeVat);
        formItem.setValue(`nServiceLifeYear`, ObjProblem.nServiceLifeYear);
        formItem.setValue(`nDepreciation`, ObjProblem.nDepreciation);

    }

    const handleDelete = (sID) => {
        DialogFn.Submit(`${I18n.SetText("PublishDoc.sConfirmDel")}`, () => {
            let arrClone: any[] = lstData;
            let _arrClone = arrClone.filter((f) => f.sID !== sID);
            setData(_arrClone);
            DialogFn.Success("ลบข้อมูลสำเร็จ");
        });
    };

    const handleDeleteTable = (arrID) => {
        DialogFn.Submit(`${I18n.SetText("PublishDoc.sConfirmDel")}`, () => {
            let arrClone: any[] = lstData;
            let arrnParentID = arrClone.length > 0 ? arrClone.filter((f) => arrID.includes(f.nID)).map((m) => m.nEquipmentID) : [];
            let _arrClone = arrClone.filter((f) => !arrID.includes(f.nID));
            let _arrCloneSub = _arrClone.filter((f) => !arrnParentID.includes(f.nParentID));

            // เรียง Order ใหม่
            if (_arrCloneSub.length > 0) {
                let nOrder = 1;
                _arrCloneSub.filter((f) => f.isHead).forEach((f) => {
                    f.nOrder = nOrder;
                    nOrder++;
                });
            }

            setData(_arrCloneSub);
            DialogFn.UnBlockUI();
            DialogFn.Success("ลบข้อมูลสำเร็จ");
            DialogFn.CloseSubmit()

            setSelected([]);
        });

    };

    const handleClick = (id: number) => {

        const selectedIndex = selected.indexOf(id);
        let newSelected: readonly number[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected = lstData.map((n) => n.nID);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };


    const CallTable = useCallback(() => {
        return (
            <FormProvider {...formNew}>
                <TableContainer id='table-receive' component={Paper}>
                    <Table sx={{ minWidth: 1400, marginTop: 5 }} >
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox" align='center' style={{ width: '60px', }}>
                                    <Checkbox
                                        color="primary"
                                        indeterminate={selected.length > 0 && selected.length < lstData.length}
                                        checked={lstData.length > 0 && selected.length === lstData.length}
                                        disabled={!isPermission || sID != null}
                                        onChange={handleSelectAllClick}
                                        inputProps={{
                                            'aria-label': 'select all',
                                        }}
                                    />
                                </TableCell>
                                <TableCell padding='none' align='center' style={{ width: '100px', }}>
                                </TableCell>
                                <TableCell padding='none' align='center' style={{ width: '50px', }}>ที่</TableCell>
                                <TableCell padding='none' align='center' style={{ width: '150px', }}>รหัสครุภัณฑ์</TableCell>
                                <TableCell padding='none' align='center' style={{ width: '150px', }}>รหัสสินทรัพย์ (GFMIS)</TableCell>
                                <TableCell padding='none' align='center' style={{ width: '150px', }}>เลขที่ใบโอน</TableCell>
                                <TableCell padding='none' align='center' style={{ width: '150px', }}>ประเภท</TableCell>
                                <TableCell padding='none' align='center' style={{ width: '400px', }}>รายการ</TableCell>
                                <TableCell padding='none' align='center' style={{ width: '150px', }}>จำนวน</TableCell>
                                <TableCell padding='none' align='center' style={{ width: '150px', }}>หน่วยนับ</TableCell>
                                <TableCell padding='none' align='center' style={{ width: '150px', }}>ราคาต่อหน่วย</TableCell>
                                <TableCell padding='none' align='center' style={{ width: '100px', }}>หมายเหตุ</TableCell>
                            </TableRow>
                        </TableHead>
                        {lstData.length > 0 ? (
                            <TableBody>
                                {lstData.map((item, index) => {
                                    const isItemSelected = isSelected(item.nID);

                                    return (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer' }} key={item.nID}>
                                            <TableCell padding="checkbox" align='center'>
                                                {item.isHead &&
                                                    (
                                                        <Grid item xs={12} md={12} >
                                                            <Checkbox
                                                                color="primary"
                                                                checked={isItemSelected}
                                                                onClick={() => handleClick(item.nID)}
                                                                inputProps={{
                                                                    "aria-labelledby": `aria-${item.nID}`,
                                                                }}
                                                                disabled={!isPermission || sID != null}
                                                            />
                                                        </Grid>
                                                    )
                                                }
                                            </TableCell>
                                            <TableCell padding='none' align='center'>
                                                {item.isHead ?
                                                    (

                                                        <Grid container spacing={2} key={item.sID}>

                                                            <Grid item xs={12} md={6} >
                                                                <BtnAdd
                                                                    IsDisabled={!isPermission || sID != null}
                                                                    IsCircleWithOutText
                                                                    id={'btnAdd'}
                                                                    onClick={formNew.handleSubmit((e) => onSumitTableItem(item.nEquipmentID, item.nParentID))}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} >
                                                                <BtnEdit
                                                                    IsCircleWithOutText
                                                                    key={item.sID + item.nOrder}
                                                                    id="btnEdit"
                                                                    onClick={() => onEdit(item.sID, item)}
                                                                    IsDisabled={!isPermission || sID != null}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    ) :
                                                    <Grid container justifyContent={"center"} spacing={2} key={item.sID}>
                                                        <Grid item xs={12} md={12} >
                                                            <BtnDelete
                                                                IsCircleWithOutText
                                                                id={'btnDelete' + item.nID}
                                                                onClick={() => handleDelete(item.sID)}
                                                                IsDisabled={!isPermission || sID != null}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                }
                                            </TableCell>
                                            <TableCell padding='none' align='center'>
                                                {item.nOrder}
                                            </TableCell>
                                            <TableCell padding='none' align='center'>
                                                {item.sEquipmentNo}
                                            </TableCell>
                                            <TableCell padding='none' align='center'>
                                                {item.sGFMISNo}
                                            </TableCell>
                                            <TableCell padding='none' align='center'>
                                                {item.sSlipNo}
                                            </TableCell>
                                            <TableCell padding='none' align='center'>
                                                {item.sEquipmentType}
                                            </TableCell>
                                            {item.isHead ?
                                                (
                                                    <>
                                                        <TableCell padding='none' align='left'>
                                                            {item.sEquipment}
                                                        </TableCell>
                                                        <TableCell padding='none' align='center'>
                                                            {item.nAmount}
                                                        </TableCell>
                                                        <TableCell padding='none' align='center'>
                                                            {item.sEquipmentUnit}
                                                        </TableCell>
                                                        <TableCell padding='none' align='center'>
                                                            <Typography
                                                            >
                                                                {formatNumber(item.nPricePerUnit, 0)}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell padding='none' align='center'>
                                                            <BtnRemark
                                                                id={"btn"}
                                                                IsCircleWithOutText
                                                                className='btnicon-remark'
                                                                onClick={() => onOpenModal(item.nID, item.sRemark, item.isDelete)}
                                                            />
                                                        </TableCell>
                                                    </>
                                                ) :
                                                <>

                                                    <TableCell padding='none' align='center'>
                                                        <TextBoxItem
                                                            required={true}
                                                            id={`sEquipment_${item.nID}`}
                                                            name={`sEquipment_${item.nID}`}
                                                            maxLength={250}
                                                            type={'text'}
                                                            IsShowMessageError={false}
                                                            disabled={!isPermission || sID != null}
                                                        />
                                                    </TableCell>
                                                    <TableCell padding='none' align='center'>
                                                        <InputNumberItem
                                                            id={`nAmount_${item.nID}`}
                                                            name={`nAmount_${item.nID}`}
                                                            required={true}
                                                            IsShowMessageError={false}
                                                            IsAllowScientific={false}
                                                            maxDigits={0}
                                                            ShowDigits={0}
                                                            maxInteger={10}
                                                            IsComma={true}
                                                            disabled={!isPermission || sID != null}

                                                        />
                                                    </TableCell>
                                                    <TableCell padding='none' align='center'>
                                                        <TextBoxItem
                                                            required={true}
                                                            id={`sUnitName_${item.nID}`}
                                                            name={`sUnitName_${item.nID}`}
                                                            maxLength={50}
                                                            IsShowMessageError={false}
                                                            type={'text'}
                                                            disabled={!isPermission || sID != null}
                                                        />
                                                    </TableCell>
                                                    <TableCell >
                                                        <InputNumberItem
                                                            id={`nPricePerUnit_${item.nID}`}
                                                            name={`nPricePerUnit_${item.nID}`}
                                                            required={true}
                                                            IsShowMessageError={false}
                                                            IsAllowScientific={false}
                                                            maxDigits={2}
                                                            ShowDigits={2}
                                                            maxInteger={10}
                                                            IsComma={true}
                                                            disabled={!isPermission || sID != null}
                                                        />
                                                    </TableCell>
                                                    <TableCell padding='none' align='center'>
                                                        <BtnRemark
                                                            id={"btn"}
                                                            IsCircleWithOutText
                                                            className='btnicon-remark'
                                                            onClick={() => onOpenModal(item.nID, item.sRemark, item.isDelete)}
                                                        />
                                                    </TableCell>

                                                </>
                                            }
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        ) : (
                            <TableRow key={"r-no-data"}>
                                <TableCell align="center" colSpan={12}>
                                    ไม่พบข้อมูล
                                </TableCell>
                            </TableRow>
                        )}
                    </Table>
                </TableContainer>
                <Grid item style={{ display: 'none' }}>
                    <BtnAdd id="AddDuration"
                        onClick={formNew.handleSubmit((e) => (err) => {
                            document.getElementById(Object.keys(err)[0])?.focus();
                        })}
                    />
                </Grid>
            </FormProvider>
        );
    }, [lstData, selected]);

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6} >
                        <TextBoxItem
                            required={true}
                            label={`${I18n.SetText("Equipment.sGovernment")}`}
                            id={'sGovernment'}
                            name={'sGovernment'}
                            maxLength={250}
                            type={'text'}
                            IsShowMessageError
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SelectItem
                            id="nGovernmentUnitID"
                            name={"nGovernmentUnitID"}
                            label={`${I18n.SetText("Equipment.nGovernmentUnit")}`}
                            placeholder={`${I18n.SetText("Equipment.nGovernmentUnit")}`}
                            options={arrGovernmentUnit}
                            required={true}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} >
                        <TextBoxItem
                            required={true}
                            label={`${I18n.SetText("Equipment.sOrderNo")}`}
                            id={'sOrderNo'}
                            name={'sOrderNo'}
                            maxLength={250}
                            type={'text'}
                            IsShowMessageError
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <DatePickerItem
                            maxDate={moment()}
                            required={true}
                            name={"dReceive"}
                            id={"dReceive"}
                            label={`${I18n.SetText("Equipment.sReceiveDate")}`}
                            fullWidth
                            disabled={!isPermission || sID != null}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <RadioListItem
                            id={"nMoneyTypeID"}
                            name={"nMoneyTypeID"}
                            required={true}
                            options={arrMoneyType}
                            disabled={!isPermission}
                            label={`${I18n.SetText("Equipment.sMoneyType")}`}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <RadioListItem
                            id={"nMethodTypeID"}
                            name={"nMethodTypeID"}
                            required={true}
                            options={arrMethodType}
                            disabled={!isPermission}
                            label={`${I18n.SetText("Equipment.sMethodType")}`}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} >
                        <TextBoxItem
                            required={true}
                            label={`${I18n.SetText("Equipment.sSellerName")}`}
                            id={'sSellerName'}
                            name={'sSellerName'}
                            maxLength={250}
                            type={'text'}
                            IsShowMessageError
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} >
                        <TextBoxItem
                            required={true}
                            label={`${I18n.SetText("Equipment.sAddress")}`}
                            id={'sAddress'}
                            name={'sAddress'}
                            maxLength={250}
                            type={'text'}
                            IsShowMessageError
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <UploadFile
                            id="sFileID"
                            name={"sFileID"}
                            label={`${I18n.SetText("Equipment.sFile")}`}
                            required={false}
                            arrFile={arrImport}
                            setarrFile={setarrImport}
                            sFolderTemp="ReceiveEquipmentImage"
                            IsFolder={false}
                            IsMultiple={true}
                            Extension={[...Extension.ImagePDF]}
                            nLimitFile={30}
                            sLimitFile={"MB"}
                            onClearFile={() => { }}
                            sPositionText="right"
                            IsCrop={true}
                            cropRatio={16 / 9}
                            cropMovable={true}
                            cropResize={true}
                            cropShape='retangle'
                            modeDisplay='gallery'
                            disabled={!isPermission}
                        />
                    </Grid>

                    <FormProvider {...formItem}>
                        <Grid item xs={12} md={12} >
                            <Grid item className='div-breadcrumbs-Equipment' style={{ marginTop: 20 }}>
                                <Typography variant="h6" style={{ fontSize: 'large', }}> {`${I18n.SetText("Equipment.sDetail")}`}</Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <TextBoxItem
                                required={true}
                                label={`${I18n.SetText("Equipment.sEquipmentNo")}`}
                                id={'sEquipmentNo'}
                                name={'sEquipmentNo'}
                                maxLength={50}
                                type={'text'}
                                IsShowMessageError
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <TextBoxItem
                                required={false}
                                label={`${I18n.SetText("Equipment.sGFMISNo")}`}
                                id={'sGFMISNo'}
                                name={'sGFMISNo'}
                                maxLength={50}
                                type={'text'}
                                IsShowMessageError
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <TextBoxItem
                                required={false}
                                label={`${I18n.SetText("Equipment.sSlipNo")}`}
                                id={'sSlipNo'}
                                name={'sSlipNo'}
                                maxLength={50}
                                type={'text'}
                                IsShowMessageError
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <SelectItem
                                id="nEquipmentTypeID"
                                name={"nEquipmentTypeID"}
                                label={`${I18n.SetText("Equipment.EquipmentType")}`}
                                placeholder={`${I18n.SetText("Equipment.EquipmentType")}`}
                                options={arrEquipmentType}
                                required={true}
                                disabled={!isPermission}
                                onChange={(e) => {
                                    setsEquipmentType(e != null ? e.label : "");
                                    setnEquipmentType(e != null ? e.value : "");
                                }}
                            />
                        </Grid>
                        {nEquipmentType === 99999999 &&
                            <Grid item xs={12} md={7} >
                                <TextBoxItem
                                    required={nEquipmentType === 99999999}
                                    label={`${I18n.SetText("Equipment.sEquipmentTypeOther")}`}
                                    id={'sEquipmentType'}
                                    name={'sEquipmentType'}
                                    maxLength={250}
                                    type={'text'}
                                    IsShowMessageError
                                    disabled={!isPermission}
                                />
                            </Grid>
                        }
                        <Grid item xs={12} md={12} >
                            <TextBoxItem
                                required={true}
                                label={`${I18n.SetText("Equipment.sEquipment")}`}
                                id={'sEquipment'}
                                name={'sEquipment'}
                                maxLength={250}
                                type={'text'}
                                IsShowMessageError
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item xs={12} md={nEquipmentUnit === 99999999 ? 4 : 6}>
                            <SelectItem
                                id="nEquipmentUnitID"
                                name={"nEquipmentUnitID"}
                                label={`${I18n.SetText("Equipment.EquipmentUnitID")}`}
                                placeholder={`${I18n.SetText("Equipment.EquipmentUnitID")}`}
                                options={arrEquipmentUnit}
                                required={true}
                                disabled={!isPermission}
                                onChange={(e) => {
                                    setsEquipmentUnit(e != null ? e.label : "");
                                    setnEquipmentUnit(e != null ? e.value : "");
                                }}
                            />
                        </Grid>
                        {nEquipmentUnit === 99999999 &&
                            <Grid item xs={12} md={4} >
                                <TextBoxItem
                                    required={nEquipmentUnit == 99999999}
                                    label={`${I18n.SetText("Equipment.EquipmentUnitOther")}`}
                                    id={'sUnitName'}
                                    name={'sUnitName'}
                                    maxLength={250}
                                    type={'text'}
                                    IsShowMessageError
                                    disabled={!isPermission}
                                />
                            </Grid>
                        }
                        <Grid item xs={12} md={nEquipmentUnit === 99999999 ? 4 : 6} >
                            <InputNumberItem
                                id={`nPricePerUnit`}
                                name={`nPricePerUnit`}
                                label={`${I18n.SetText("Equipment.sPricePerUnit")}`}
                                required={true}
                                IsShowMessageError={false}
                                IsAllowScientific={false}
                                maxDigits={2}
                                ShowDigits={2}
                                maxInteger={10}
                                IsComma={true}
                                disabled={!isPermission}
                                endAdornment={"บาท"}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <InputNumberItem
                                id={`nPriceIncludeVat`}
                                name={`nPriceIncludeVat`}
                                label={`${I18n.SetText("Equipment.sPriceIncludeVat")}`}
                                required={true}
                                IsShowMessageError={false}
                                IsAllowScientific={false}
                                maxDigits={2}
                                ShowDigits={2}
                                maxInteger={10}
                                IsComma={true}
                                disabled={!isPermission}
                                endAdornment={"บาท"}
                                onChange={() => {
                                    nSum();
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <InputNumberItem
                                id={`nServiceLifeYear`}
                                name={`nServiceLifeYear`}
                                label={`${I18n.SetText("Equipment.sServiceLifeYear")}`}
                                required={true}
                                IsShowMessageError={false}
                                IsAllowScientific={false}
                                maxDigits={0}
                                ShowDigits={0}
                                maxInteger={10}
                                IsComma={true}
                                disabled={!isPermission}
                                onChange={() => {
                                    nSum();
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} >
                            <InputNumberItem
                                id={`nDepreciation`}
                                name={`nDepreciation`}
                                label={`${I18n.SetText("Equipment.sDepreciation")}`}
                                required={true}
                                IsShowMessageError={false}
                                IsAllowScientific={false}
                                maxDigits={2}
                                ShowDigits={2}
                                maxInteger={10}
                                IsComma={true}
                                disabled={true}
                                endAdornment={"บาท"}
                            />
                        </Grid>
                    </FormProvider>
                    <Grid item container justifyContent="flex-end" xs={12} md={12}>
                        <BtnAdd id={"btnSave"}
                            txt='เพิ่มข้อมูล'
                            IsDisabled={!isPermission || sID != null}
                            onClick={formItem.handleSubmit((e) => onSumitTable(e), (err) => console.log("err", err))}
                        />
                    </Grid>
                    <CallTable />
                    {selected.length > 0 &&
                        <Grid container justifyContent="flex-start" sx={{ mt: 2, marginLeft: 1 }}>
                            <Grid item xs={12} md={12} >
                                <BtnDelete
                                    IsCircleWithOutText
                                    id={'btnDelete'}
                                    onClick={() => handleDeleteTable(selected)}
                                />
                            </Grid>
                        </Grid>
                    }
                </Grid>
                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit((e) => onSubmit(e), (err) => console.log("err", err))}
                        />
                    </Grid>
                </Grid>

                <DialogPreview
                    IsOpen={isOpen}
                    IsBackdropClick={false}
                    onClose={() => { setisOpen(false); }}
                    JsxDialogAction
                    CloseSave={sID == null}
                    onClick={() => { onSummitRemark(); }}
                    Close={true}
                    sMaxWidth='sm'
                    bgColor={"#a07300"}
                    Color='white'
                    Title={'หมายเหตุ'}
                >
                    <Grid container justifyContent={"center"} >
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                placeholder=""
                                label='หมายเหตุ'
                                name="sRemark"
                                maxLength={500}
                                id={"sRemark"}
                                required={false}
                                disabled={!isPermission || sID != null}
                            />
                        </Grid>
                    </Grid>
                </DialogPreview >
            </FormProvider>
        </React.Fragment >
    );
}
export default EquipmentReceiveForm;

export interface EquipmentReceiveItem {
    sID?: string;
    nOrder?: number;
    sEquipmentNo?: string;
    sGFMISNo?: string;
    sSlipNo?: string;
    nEquipmentTypeID?: number;
    sEquipmentType?: string;
    sEquipment?: string;
    nAmount?: number;
    nEquipmentUnitID?: number;
    sEquipmentUnit?: string;
    nPricePerUnit?: number;
    sRemark?: string;
    isHead?: boolean;
    IsDelete?: boolean;
    nDepreciation?: number;
    nPriceIncludeVat?: number;
    nServiceLifeYear?: number;
    nID?: number;
    nParentID?: number;
    nEquipmentID?: number;
    nEquipmentItemID?: number;
    nEquipmentItemIDOrder?: number;
    nEquipmentIDOrder?: number;
    isDelete?: boolean;
}

